<template>
  <v-app>
    <v-main>
      <v-container fluid id="repair-calculator"
                   style="
         background-image: url(https://cpsrecall.s3-us-west-2.amazonaws.com/images/Grey-Background.jpg);
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
        min-height: 100%;
        position: absolute;
        padding: 3%;
        padding-bottom: 150px;
        background-repeat: no-repeat;
        background-attachment: fixed;
    ">
        <link href="https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css" rel="stylesheet">
        <v-app-bar
                color="rgb(247, 248, 249)"
                light
        >
          <v-toolbar-title>REPAIR ESTIMATE REPORT</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn :href="returnLink" class="mr-3 rc-hide-small">
            Return to Report
          </v-btn>
          <v-btn v-if="!demoMode" :href="projectUrl+$route.params.token + '/pdf'" class="rc-hide-small" >
            PRINT
          </v-btn>
        

          <v-menu
                  left
                  bottom
          >
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                      v-if="!demoMode"
                      :href="projectUrl+$route.params.token + '/pdf'"
              >
                <v-list-item-title>Download PDF</v-list-item-title>
              </v-list-item>
              <v-list-item
                      :href="projectUrl+$route.params.token + '/pdf'"
              >
                <v-list-item-title>Return to Report</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

        </v-app-bar>
        <v-row v-if="askForZip" justify="center">
          <v-col cols="12" md="8" lg="6" class="px-0">
            <v-form class="rc-whitebg pb-4">
              <v-text-field :rules="zipRules" v-mask="'#####'" v-model="zip" dense label="Location Zip Code"></v-text-field>
              <v-btn class="mr-4" @submit.prevent="" @click="submit">submit</v-btn>
            </v-form>
          </v-col>
        </v-row>

        <rc-project v-for="(project, index) in projects" :key="project.listId" v-bind:keys="keys" v-bind:RCId="index" v-bind:zip="zip" @deleteProject="removeProject" @identifyProject="nameProject" v-bind:RCProject="project"> </rc-project>
        <v-row justify="center">
          <v-col cols="3" lg="2" @click="addProject" class="mt-6 rc-light rc-pointer text-center">
            + Add another project
          </v-col>
        </v-row>

      </v-container>
    </v-main>
  </v-app>

</template>

<script>
import RCProject from './components/RCProject.vue'

export default {
  data: function() {
    return {
      projects: [
        {
            apiId: 0,
            listId: 1,
            projectId: 0,
            response: {},
            measure: false,
            units: 1,
            name: 'Project Search',
            url: 'https://cpsrecall.s3-us-west-2.amazonaws.com/RepairCalculatorImgs/CalculatorDefault.jpg'
        }
      ],
      count: 1,
      keys: {},
      projectUrl: process.env.VUE_APP_URL,
      returnLink: '',
      windowWidth: window.innerWidth,
      askForZip: false,
      zip: null,
      zipRules: [
        v => !!v || 'Zip is Required for Local Data',
        v => v.length > 4 || 'Zip must be 5 characters',
      ],
      demoMode: false

    };

  },
  methods: {
    addProject: function() {
      this.count += 1;
      this.projects.push({
        listId: this.count,
        apiId: 0,
        name: 'Project Search',
        url: 'https://cpsrecall.s3-us-west-2.amazonaws.com/RepairCalculatorImgs/CalculatorDefault.jpg'
      });
      console.log(this.projects);
      // var componentClass = Vue.extend(RCProject);
      // var insta`nce = new componentClass();


    },
    removeProject: function(key) {
      console.log('length of projects: ', this.projects.length);
      // this.projects.splice(key, 1);

      let choppingBlock = null;
      for(let i=0; i < this.projects.length; i++) {
        console.log('iterator: ', i);

        if(this.projects[i].listId === key) {
          // this.projects.splice(i, 1);
          console.log('Here I would splice: ', i);
          choppingBlock = i;
        }
      }
      this.projects.splice(choppingBlock, 1);
      console.log('Just spliced: ', this.projects);
    },
    nameProject: function(info) {
        console.log('project info: ', info);
      this.projects[info.listId] = info;
      // this.projects[info.listId].url = info.project;
    },
    submit() {
      if (this.zip.toString().length == 5) {
        this.askForZip = false;
      }
    }
  },
  components: {
    'rc-project': RCProject
  },
  created: function() {
    this.$http.get(`${this.$route.params.token}`)
            .then(response => {
              let responseObject = response.body;
              let responseObjectJson = JSON.parse(responseObject);
              this.keys = responseObjectJson.apikeys;
              console.log('Keys: ', this.keys);
              if (responseObjectJson.projects !== undefined) {
                console.log('projects: ', responseObjectJson);
                let highId = 0;
                responseObjectJson.projects.forEach(function(project) {
                  if (project.listId > highId) {
                    highId = project.listId;
                  }
                });
                this.count = highId;
                this.projects = responseObjectJson.projects;
              }
              if (responseObjectJson.reportLink !== undefined) {
            this.returnLink = process.env.VUE_APP_HM_BASE_URL + responseObjectJson.reportLink;
              }
            }, error => {
              console.log(error);
            });

    this.askForZip = this.$route.params.token ? false : true;
    this.demoMode = this.$route.params.token ? false : true;


  },
}
</script>

<style>
  #rc-report {
    /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#353535+0,353535+25,d8d9da+25,ced0d1+100 */
    background: #d8d9da; /* Old browsers */
  }
  .rc-dark {
    background-color: #d8d9da;
    color: rgba(0,0,0,.87);
  }
  .rc-light {
    background-color: rgb(214, 214, 214);
  }
  .wide-border {
    border-width: 7px !important;
    border: solid 7px #ffffff;
  }

  .project-image {
    min-height: 200px;
    background-position-y: center;
  }


  .container {
    font-family: myriad-pro,frutiger,"Myriad Pro","Helvetica Neue","Helvetica",Arial,sans-serif;
  }

  body {
    background-image: url(https://cpsrecall.s3-us-west-2.amazonaws.com/images/Grey-Background.jpg);
    background-repeat: no-repeat;
    background-attachment: fixed;
  }

  @media (min-width: 960px) {
    #rc-report {
      /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#353535+0,353535+25,d8d9da+25,ced0d1+100 */
      background: #353535; /* Old browsers */
      background: -moz-linear-gradient(left,  #353535 0%, #353535 25%, #d8d9da 25%, #ced0d1 100%); /* FF3.6-15 */
      background: -webkit-linear-gradient(left,  #353535 0%,#353535 25%,#d8d9da 25%,#ced0d1 100%); /* Chrome10-25,Safari5.1-6 */
      background: linear-gradient(to right,  #353535 0%,#353535 25%,#d8d9da 25%,#ced0d1 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#353535', endColorstr='#ced0d1',GradientType=1 ); /* IE6-9 */


    }
    .rc-dark {
      background-color: #353535;
      color: #fff;
    }
  }

  @media (max-width: 960px) {
    .rc-hide-small {
      display: none !important;
    }
    .project-image {
      min-height: 290px;
    }
  }

  .rc-pointer {
    cursor: pointer;
  }
  .rc-whitebg {
    background-color: white;
    border-radius: 2px;
    padding: 14px 10px 0 !important;
  }
</style>
